var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"5c754e75d5484a37a18ae47e581a0e6cb74d3cfc"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  
  // Adjust this value to control how many errors are sent to Sentry
  // Definir um valor baixo no início e ajustar conforme necessário
  tracesSampleRate: 0.2,
  
  // Capturar erros de desempenho se estiverem dentro do limite
  // Isto irá gravar rastreamentos de desempenho para monitoração
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  
  // Set to true to debug issues with sending events to Sentry
  debug: process.env.NODE_ENV === 'development',
  
  integrations: [
    // Automatically instrument React components for better error understanding
    new Sentry.Replay({
      // Configure additional options here
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
}); 